import { render, staticRenderFns } from "./PdfViewWrapper.vue?vue&type=template&id=eabf0e74&lang=html"
import script from "./PdfViewWrapper.vue?vue&type=script&lang=js"
export * from "./PdfViewWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../modules/headpower/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports